import { render, staticRenderFns } from "./MustRead.vue?vue&type=template&id=2335bb68&scoped=true"
import script from "./MustRead.vue?vue&type=script&lang=js"
export * from "./MustRead.vue?vue&type=script&lang=js"
import style0 from "./MustRead.vue?vue&type=style&index=0&id=2335bb68&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2335bb68",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2335bb68')) {
      api.createRecord('2335bb68', component.options)
    } else {
      api.reload('2335bb68', component.options)
    }
    module.hot.accept("./MustRead.vue?vue&type=template&id=2335bb68&scoped=true", function () {
      api.rerender('2335bb68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/MustRead.vue"
export default component.exports